import React from "react";

interface TourContextValue {
  restartTour: (() => void) | null;
  setRestartTour: (fn: (() => void) | null) => void;
}

const TourContext = React.createContext<TourContextValue>({
  restartTour: null,
  setRestartTour: () => {},
});

export function TourContextProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const restartRef = React.useRef<(() => void) | null>(null);
  const [hasRestart, setHasRestart] = React.useState(false);

  const setRestartTour = React.useCallback((fn: (() => void) | null) => {
    restartRef.current = fn;
    setHasRestart(fn !== null);
  }, []);

  const restartTour = React.useCallback(() => {
    restartRef.current?.();
  }, []);

  const value = React.useMemo(
    () => ({ restartTour: hasRestart ? restartTour : null, setRestartTour }),
    [hasRestart, restartTour, setRestartTour]
  );

  return <TourContext.Provider value={value}>{children}</TourContext.Provider>;
}

export function useTourContext() {
  return React.useContext(TourContext);
}

export default TourContext;
